import React from 'react'
import {withTranslation} from 'react-i18next'

import {PinIcon} from 'components/CustomIcons'
import useUserContext from 'components/User/useUserContext'
import BButton from 'components/Form/Fields/BButton'

const WarningDeliveryAddress = ({t}) => {
  const {delivery, openDeliveryModal} = useUserContext()

  return (
    !delivery ? (
      <div className='notice warningDeliveryAddress'>
        <div>{t('You have to provide the exact delivery address.')}</div>
        <div><BButton red onClick={openDeliveryModal}><PinIcon/> {t('CHANGE DELIVERY ADDRESS')}</BButton></div>
      </div>
    ) : ''
  )
}

export default withTranslation()(WarningDeliveryAddress)
